import { Config } from '@adornis/config/config.js';

export const config = new Config('personalverwaltung', {
  MS_CLIENT_SECRET: { client: false, env: true, name: 'MS_CLIENT_SECRET', required: true },
  MS_CLIENT_ID: { client: false, env: true, name: 'MS_CLIENT_ID', required: true },
  MS_TENANT_ID: { client: false, env: true, name: 'MS_TENANT_ID', required: true },
  MS_TENANT_DOMAIN: { client: true, env: true, name: 'MS_TENANT_DOMAIN', required: true },
  INFO_MAIL: { client: false, env: true, name: 'INFO_MAIL', required: true },
  OPENAI_KEY: { client: false, env: true, name: 'OPENAI_KEY', required: true },
  LOG_LEVEL: { client: false, env: true, name: 'INFO_MAIL', required: true },
  SMTP_HOST: { client: false, env: true, name: 'SMTP_HOST', required: true },
});
